// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__11o2-","label":"Category_label__3Va8C","content":"Category_content__1g1J5","header":"Category_header__1WaKK","location":"Category_location__1zBrp"};